import { AppIntegrationsRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state', '$location', '$rootScope', '$translate'];

class DeployBreadcrumbController {

    constructor($scope, $state, $location, $rootScope, $translate) {

        this.$scope = $scope;
        this.$state = $state;
        this.$location = $location;
        this.$rootScope = $rootScope;
        this.$scope.currentPage = $state.current.name;
        this.$translate = $translate;

        this.$scope.breadcrumbSteps = [
            { id: 'step1', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.select_os') },
            { id: 'step2', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.select_license') },
            { id: 'step3', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.download') },
            { id: 'step4', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.done') },
        ];

        const queryParams = this.$location.search();
        const deviceCategory = queryParams.deviceCategory || 'all';

        this.updateBreadcrumb();

        this.$scope.$watch('inputdata', () => {

            this.updateBreadcrumb();

        });

        setTimeout(() => {

            this.buildBreadcrumb();
            this.updateBreadcrumb();

        }, 0);

        this.$scope.breadcrumbClick = (stepNumber) => {

            angular.element('.deploy-modal .deploy-steps div').removeClass('disabled');

            let route = $state.current.name;

            if (route.indexOf('.deploy') === -1) {

                route += '.deploy';

            }

            // Products
            if (this.$state.current.name.indexOf('.products') > -1) {

                // It has the select os step
                if (this.$scope.breadcrumbSteps.length === 3) {

                    if (stepNumber === 'step1') {

                        const params = { deviceId: 'new', deployType: 'other', os: '' };

                        this.$scope.changewizard(route, params, {
                            reload: false,
                        });

                        Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Select OS',
                            page: 'Products',
                        });

                    }

                    if (stepNumber === 'step2') {

                        const params = { deviceId: 'new', os: this.$scope.inputdata.os };

                        this.$scope.changewizard(route, params, {
                            reload: false,
                        });

                        Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Download',
                            Page: 'Products',
                        });

                    }

                } else if (this.$scope.breadcrumbSteps.length === 2) {

                    if (stepNumber === 'step1') {

                        const params = { deviceId: 'new', os: this.$scope.inputdata.os };

                        this.$scope.changewizard(route, params, {
                            reload: false,
                        });

                        Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Download',
                            page: 'Products',
                        });

                    }

                }

            // Homepage & Devices

            } else if (this.$state.current.name.indexOf('.home') > -1
                || this.$state.current.name.indexOf('.devices') > -1) {

                let params;
                let page;

                if (this.$state.current.name.indexOf('.home') > -1) {

                    page = 'Homepage';

                } else {

                    page = 'Devices';

                }

                if (stepNumber === 'step1') {

                    params = { deviceCategory, appId: '', os: '' };

                    Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                        'Button label': 'Select OS',
                        page,
                    });

                } else if (stepNumber === 'step2') {

                    params = { os: this.$scope.inputdata.os, appId: '' };

                    Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                        'Button label': 'Select License',
                        page,
                    });

                } else if (stepNumber === 'step3') {

                    params =
                        { os: this.$scope.inputdata.os, appId: this.$scope.inputdata.appId };

                    Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                        'Button label': 'Download',
                        page,
                    });

                }

                this.$scope.changewizard(route, params, {
                    reload: false,
                });

            // Subscriptions

            } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

                if (this.$scope.breadcrumbSteps.length === 4) {

                    let params;
                    const savedRoute = this.$rootScope.State.deploySteps[0];

                    if (stepNumber === 'step1' && savedRoute) {

                        params = {
                            deviceId: savedRoute.deviceId,
                            appId: savedRoute.appId,
                            resourceId: savedRoute.resourceId,
                            os: '',
                        };

                        Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Select OS',
                            page: 'Subscriptions',
                        });

                    }

                    if (stepNumber === 'step2' && savedRoute) {

                        params = {
                            deviceId: savedRoute.deviceId,
                            appId: savedRoute.appId,
                            resourceId: savedRoute.resourceId,
                            os: savedRoute.os,
                        };

                        if (savedRoute && (savedRoute.os === 'ios' || savedRoute.os === 'android')) {

                            this.$scope.changewizard(route, params, {
                                reload: false,
                            });

                            Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                                'Button label': 'Select License',
                                page: 'Subscriptions',
                            });

                        }

                        return;

                    }

                    if (stepNumber === 'step3' && savedRoute) {

                        if (!savedRoute.currentAppId) {

                            params = {
                                deviceId: savedRoute.deviceId,
                                appId: savedRoute.appId,
                                resourceId: savedRoute.resourceId,
                                os: savedRoute.os,
                            };

                        } else {

                            params = {
                                appId: savedRoute.currentAppId,
                                resourceId: 'new',
                                os: savedRoute.os,
                            };

                        }

                        Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Download',
                            page: 'Subscriptions',
                        });

                    }

                    if (savedRoute) {

                        this.$scope.changewizard(route, params, {
                            reload: false,
                        });

                    }

                }

            } else if (this.$state.current.name.indexOf('.device-details') > -1) {

                if (stepNumber === 'step1' && !this.$scope.inputdata.completedSteps) {

                    const params = { appId: this.$scope.inputdata.appId };

                    this.$scope.changewizard(route, params, {
                        reload: false,
                    });

                    Mixpanel.send('ConnectWeb Modal Breadcrumb Click', {
                        'Button label': 'Download',
                        page: 'Device Details',
                    });

                }


            }

        };

        if (queryParams.autoInstall === 'true' || this.$scope.inputdata.autoInstall === 'true') {

            this.$scope.hideBreadcrumb = true;

        }

    }

    buildBreadcrumb() {

        const queryParams = this.$location.search();

        if (queryParams.autoInstall === 'true' || queryParams.os === 'webapp'
            || this.$scope.inputdata.autoInstall === 'true') {

            this.$scope.hideBreadcrumb = true;

        }

        // Build the breadcrumb items

        // Products
        if (this.$state.current.name.indexOf('.products') > -1) {

            const appDetails = AppIntegrationsRepository.getById(this.$state.params.resourceId);

            if (appDetails.attributes.platform.type.length > 1) {

                this.$scope.breadcrumbSteps = [
                    { id: 'step1', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.select_os') },
                    { id: 'step2', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.download') },
                    { id: 'step3', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.done') },
                ];

            } else {

                this.$scope.breadcrumbSteps = [
                    { id: 'step1', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.download') },
                    { id: 'step2', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.done') },
                ];

            }

        } else if (this.$state.current.name.indexOf('.device-details') > -1) {

            this.$scope.breadcrumbSteps = [
                { id: 'step1', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.download') },
                { id: 'step2', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.done') },
            ];

        }

    }

    updateBreadcrumb() {

        const queryParams = this.$location.search();

        // Deploy on an existing device
        if (this.$scope.inputdata.completedSteps) {

            this.$scope.breadcrumbSteps.forEach((step) => {

                step.status = 'done';

            });

            return;

        }

        // Products
        if (this.$state.current.name.indexOf('.products') > -1) {

            if (this.$scope.breadcrumbSteps.length === 3) {

                // Select OS
                if ((queryParams.deployType === 'other' && queryParams.deviceId)
                || (queryParams.deviceId === 'new' && queryParams.autoInstall === 'false')) {

                    this.$scope.breadcrumbSteps[0].status = 'active';
                    this.$scope.breadcrumbSteps[1].status = '';
                    this.$scope.breadcrumbSteps[2].status = '';

                // Download/send email screen

                } else if (((queryParams.os !== 'android' || queryParams.os !== 'ios')
                    && !this.$scope.inputdata.showSuccessScreen)
                    || (queryParams.deployType === 'other' && queryParams.os && !this.$scope.inputdata.showSuccessScreen)) {

                    this.$scope.breadcrumbSteps[0].status = 'done';
                    this.$scope.breadcrumbSteps[1].status = 'active';
                    this.$scope.breadcrumbSteps[2].status = '';

                // Donwload complete

                } else if ((queryParams.os !== 'android' || queryParams.os !== 'ios')
                    && this.$scope.inputdata.showSuccessScreen) {

                    this.$scope.breadcrumbSteps[0].status = 'done';
                    this.$scope.breadcrumbSteps[1].status = 'done';
                    this.$scope.breadcrumbSteps[2].status = 'done';

                }

            } else if (this.$scope.breadcrumbSteps.length === 2) {

                // Download/send email screen
                if ((queryParams.os !== 'android' || queryParams.os !== 'ios')
                    && !this.$scope.inputdata.showSuccessScreen) {

                    this.$scope.breadcrumbSteps[0].status = 'active';
                    this.$scope.breadcrumbSteps[1].status = '';

                // Success screen

                } else if ((queryParams.os !== 'android' || queryParams.os !== 'ios')
                    && this.$scope.inputdata.showSuccessScreen) {

                    this.$scope.breadcrumbSteps[0].status = 'done';
                    this.$scope.breadcrumbSteps[1].status = 'done';

                }

            }

            setTimeout(() => {

                this.$scope.$apply();

            }, 0);

        // Homepage & Devices

        } else if (this.$state.current.name.indexOf('.home') > -1
            || this.$state.current.name.indexOf('.devices') > -1) {

            // Select OS screen

            if (queryParams.deviceCategory === 'all' || queryParams.deviceCategory === 'mobile'
                || queryParams.deviceCategory === 'desktop') {

                this.$scope.breadcrumbSteps[0].status = 'active';
                this.$scope.breadcrumbSteps[1].status = '';
                this.$scope.breadcrumbSteps[2].status = '';
                this.$scope.breadcrumbSteps[3].status = '';

            // Select license screen

            } else if (queryParams.os && !queryParams.appId) {

                this.$scope.breadcrumbSteps[0].status = 'done';
                this.$scope.breadcrumbSteps[1].status = 'active';
                this.$scope.breadcrumbSteps[2].status = '';
                this.$scope.breadcrumbSteps[3].status = '';

            // Download/send email screen

            } else if (queryParams.os && queryParams.appId
                    && !this.$scope.inputdata.showSuccessScreen) {

                this.$scope.breadcrumbSteps[0].status = 'done';
                this.$scope.breadcrumbSteps[1].status = 'done';
                this.$scope.breadcrumbSteps[2].status = 'active';
                this.$scope.breadcrumbSteps[3].status = '';

            // Success screen

            } else if (this.$scope.inputdata.showSuccessScreen === true) {

                this.$scope.breadcrumbSteps[0].status = 'done';
                this.$scope.breadcrumbSteps[1].status = 'done';
                this.$scope.breadcrumbSteps[2].status = 'done';
                this.$scope.breadcrumbSteps[3].status = 'done';

            }

        // subscriptions

        } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

            if (this.$scope.breadcrumbSteps.length >= 4) {

                if (this.$scope.inputdata.deviceType !== 'phone') {

                    if (queryParams.deviceId === 'new' && queryParams.appId && !queryParams.os) {

                        this.$scope.breadcrumbSteps[0].status = 'active';
                        this.$scope.breadcrumbSteps[1].status = '';
                        this.$scope.breadcrumbSteps[2].status = '';
                        this.$scope.breadcrumbSteps[3].status = '';

                    } else if ((queryParams.deviceId === 'new' && queryParams.appId
                            && queryParams.os && !this.$scope.inputdata.showSuccessScreen)
                        || (queryParams.appId && queryParams.os
                            && !this.$scope.inputdata.showSuccessScreen)) {

                        this.$scope.breadcrumbSteps[0].status = 'done';
                        this.$scope.breadcrumbSteps[1].status = 'done';
                        this.$scope.breadcrumbSteps[2].status = 'active';
                        this.$scope.breadcrumbSteps[3].status = '';

                    } else if (this.$scope.inputdata.showSuccessScreen) {

                        this.$scope.breadcrumbSteps[0].status = 'done';
                        this.$scope.breadcrumbSteps[1].status = 'done';
                        this.$scope.breadcrumbSteps[2].status = 'done';
                        this.$scope.breadcrumbSteps[3].status = 'done';

                    }

                } else if (this.$scope.inputdata.deviceType === 'phone') {

                    if (queryParams.deviceId === 'new' && queryParams.appId && queryParams.os && !this.$scope.inputdata.showSuccessScreen) {

                        this.$scope.breadcrumbSteps[0].status = 'done';
                        this.$scope.breadcrumbSteps[1].status = 'active';
                        this.$scope.breadcrumbSteps[2].status = '';
                        this.$scope.breadcrumbSteps[3].status = '';

                    }

                }

            }

        } else if (this.$state.current.name.indexOf('.device-details') > -1) {

            if (queryParams.appId && !this.$scope.inputdata.showSuccessScreen) {

                this.$scope.breadcrumbSteps[0].status = 'active';
                this.$scope.breadcrumbSteps[1].status = '';

            } else if (this.$scope.inputdata.showSuccessScreen) {

                this.$scope.breadcrumbSteps[0].status = 'done';
                this.$scope.breadcrumbSteps[1].status = 'done';

            }

        }

    }

}


class DeployBreadcrumbDirective {

    constructor() {

        this.template = require('./deploy-breadcrumb.html');
        this.restrict = 'EA';
        this.replace = true;

        this.scope = {
            inputdata: '=',
            changewizard: '=',
        };

        _controllerDependencies.push(($scope, $state, $location, $rootScope, $translate) =>
            new DeployBreadcrumbController($scope, $state, $location, $rootScope, $translate));
        this.controller = _controllerDependencies;
        this.controllerAs = 'DeployBreadcrumbCtrl';

    }

}

_directiveDependencies.push(() => new DeployBreadcrumbDirective());


angular.module('directives')
    .directive('deployBreadcrumb', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/deploy-breadcrumb/deploy-breadcrumb.js